import React, { useState } from "react";
import styles from "./Login.module.css";
import { useNavigate } from "react-router-dom";
import validator from 'validator';

const Login_Window = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const { email, password } = formData;
  
  if (!email || !password) {
    setError("Заполните все поля");
    setSuccess("");
    return;
  }
  const strictLatinEmailRegex = /^[a-zA-Z0-9@._%+-]+$/;
  if (!strictLatinEmailRegex.test(email)) {
      setError("Email должен содержать только латинские буквы, цифры и символы @ . _ % + -");
      setSuccess("");
      return;
  }
  if (!validator.isEmail(email)) {
    setError("Введите корректный email адрес");
    setSuccess("");
    return;
  }

  setError("");

  try {
    const response = await fetch("/api/sign-up/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
    
    if (response.ok) {
      setSuccess("Форма успешно отправлена!");
      setFormData({ name: "", phone: "", email: "", password: "" });
    } else {
      const errorData = await response.json();
      
      if (errorData.errors) {
        const errorMessages = Object.values(errorData.errors).join(", ");
        setError(`Произошла ошибка: ${errorMessages}`);
      } else if (errorData.error) {
        setError(`Произошла ошибка: ${errorData.error}`);
      } else {
        setError("Произошла ошибка при отправке формы");
      }
    }
  } catch (err) {
    setError("Ошибка сети. Попробуйте позже.");
  }
};

const handleRegisterClick = () => {
    navigate("/registration");
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginForm}>
        <h2 className={styles.title}>Вход</h2>
        <form className={styles.form} onSubmit={handleSubmit}>
          <input
            name="email"
            placeholder="Электронная почта"
            value={formData.email}
            onChange={handleChange}
            className={styles.input}
          />
          <input
            type="password"
            name="password"
            placeholder="Пароль"
            value={formData.password}
            onChange={handleChange}
            className={styles.input}
          />
          <button type="submit" className={styles.button}>
            Войти
          </button>
        </form>
        
        <div className={styles.registerLink}>
          <span>Ещё нет аккаунта? </span>
          <button onClick={handleRegisterClick} className={styles.registerButton}>
            Регистрация
          </button>
        </div>

        {error && <p className={styles.error}>{error}</p>}
        {success && <p className={styles.success}>{success}</p>}
      </div>
    </div>
  );
};

export default Login_Window;